var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.416,
    height: 24,
    viewBox: "0 0 20.416 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597",
    transform: "translate(-349 -142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M134.7,75.248H129.3a.466.466,0,0,0-.46.543,3.2,3.2,0,0,0,6.314,0,.467.467,0,0,0-.46-.543",
    transform: "translate(227.208 87.549)",
    fill: "#E65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    d: "M140.125,69.116h-.575l-.861-8.611a6.722,6.722,0,0,0-13.378,0l-.861,8.611h-.575a2.083,2.083,0,1,0,0,4.165h16.25a2.083,2.083,0,1,0,0-4.165",
    transform: "translate(227.208 87.549)",
    fill: "#E65847"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIconSelected);
export default __webpack_public_path__ + "static/media/NotificationsIconSelected.749153ad61f8d8ac42205aa925aa9a11.svg";
export { ForwardRef as ReactComponent };